(() => {
  const start = () => {
    const root = document.querySelector('[data-max-page-transition]');
    if (!root || window.Shopify?.designMode) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const stickers = Array.from(root.querySelectorAll('[data-max-transition-sticker]'));
    if (!stickers.length) return;

    let leaving = false;
    let lastIndex = -1;

    const shouldSkip = (event, link, url) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return true;
      if (reduceMotion.matches || leaving) return true;
      if (!link || link.hasAttribute('download') || link.dataset.noPageTransition !== undefined) return true;
      if (link.target && link.target !== '_self') return true;
      if ((link.getAttribute('rel') || '').split(/\s+/).includes('external')) return true;
      if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin) return true;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return true;
      if (url.href === window.location.href) return true;
      return false;
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (_) {
        return;
      }

      if (shouldSkip(event, link, url)) return;

      event.preventDefault();
      leaving = true;

      let index = Math.floor(Math.random() * stickers.length);
      if (stickers.length > 1 && index === lastIndex) index = (index + 1) % stickers.length;
      lastIndex = index;

      stickers.forEach((sticker, stickerIndex) => {
        sticker.classList.toggle('is-active', stickerIndex === index);
      });
      root.classList.add('is-active');
      document.documentElement.classList.add('max-page-is-leaving');

      window.setTimeout(() => {
        window.location.assign(url.href);
      }, 420);
    }, { capture: true });

    window.addEventListener('pageshow', () => {
      leaving = false;
      root.classList.remove('is-active');
      document.documentElement.classList.remove('max-page-is-leaving');
      stickers.forEach((sticker) => sticker.classList.remove('is-active'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
